import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'app/shared/shared.module';
import { SearchComponent } from 'app/layout/common/search/search.component';

@NgModule({
    declarations: [SearchComponent],
    imports: [RouterModule.forChild([]), MatButtonModule, MatIconModule, SharedModule],
    exports: [SearchComponent]
})
export class SearchModule {}
